<template>
  <router-link :to="{ name: 'work', params: { medium, workId } }">
    <v-img
      :src="renderedPosterSource"
      :width="width"
      :aspect-ratio="getAspectRatio(medium)"
      @error="handlePosterLoadError"
      class="poster"
    >
      <template v-slot:placeholder>
        <v-row class="fill-height ma-0" align="center" justify="center">
          <v-progress-circular indeterminate></v-progress-circular>
        </v-row>
      </template>
    </v-img>
  </router-link>
</template>

<script>
import getAspectRatio from "../util/getAspectRatio";

export default {
  name: "work-poster",

  props: {
    src: String,
    workId: String,
    medium: String,
    width: Number,
  },

  data: function () {
    return {
      fallbackPoster: undefined,
    };
  },

  computed: {
    renderedPosterSource() {
      return this.fallbackPoster || this.src;
    },
  },

  methods: {
    getAspectRatio,

    handlePosterLoadError() {
      // TODO: Update fallback poster
      this.fallbackPoster =
        "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Placeholder_view_vector.svg/991px-Placeholder_view_vector.svg.png";
    },
  },
};
</script>
